import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  template: `
    <div class="branding">
      <a href="/" class="brand-link">
        <img
          src="/assets/images/logos/LogodeFondo.png"
          class="align-middle brand-logo"
          alt="mPayroll Logo"
        />
      </a>
    </div>
  `,
  styles: [`
    .branding {
      padding: 16px 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    
    .brand-link {
      display: flex;
      align-items: center;
      text-decoration: none;
      max-width: 100%;
    }
    
    .brand-logo {
      max-width: 100%;
      width: 160px;
      height: auto;
      transition: all 0.3s ease;
      filter: brightness(0) invert(1);
    }
    
    .brand-logo:hover {
      transform: scale(1.02);
    }
    
    :host-context(.sidebarNav-mini) .brand-logo {
      width: 40px;
      object-fit: contain;
    }
    
    :host-context(.sidebarNav-mini) .sidebarNav:hover .brand-logo {
      width: 160px;
    }
  `],
})
export class BrandingComponent {
  options = this.settings.getOptions();

  constructor(private settings: CoreService) { }
}
